import './UrlClusters.less';
import { Alert, Button } from 'antd';
import React from 'react';
import { useDeleteUrlClusterMutation } from './service';

type Props = {
    websiteGuid: string;
    clusterGuid: string;
    onFinish: () => void;
};

export default function DeleteUrlCluster({ websiteGuid, clusterGuid, onFinish }: Props) {
    const [deleteUrlCluster, { isLoading: isDeletingUrlCluster }] = useDeleteUrlClusterMutation();

    const handleDeleteButtonClicked = async () => {
        try {
            await deleteUrlCluster({ w_guid: websiteGuid, cluster_guid: clusterGuid }).unwrap();

            onFinish();
        } catch (error) {}
    };

    return (
        <div className="remove-url-cluster-form">
            <Alert
                className="remove-cluster-warning"
                message="Please note!"
                description={
                    <>
                        <div>By deleting this page group you will:</div>
                        <ul>
                            <li>Delete all URLs in this page group</li>
                            <li>Delete the reports of all URLs in this page group</li>
                        </ul>
                    </>
                }
                type="error"
                showIcon
            />

            <Button
                className="remove-cluster-button"
                type="danger"
                size="small"
                loading={isDeletingUrlCluster}
                onClick={handleDeleteButtonClicked}
            >
                Remove
            </Button>
        </div>
    );
}
